// Глобальная переменная, для хранения файлов из формы
window.formSelectFile = []

function initLoader(block) {
    // Ищем template на странице, в котором есть dom нашего бокса
    const template = document.querySelector('#template-file-preview')

    // Инпут для выбора файла
    const inputFile = block.querySelector('input[type="file"]')

    // Место, куда будем вставлять бокс с фотографией
    const contentBody = block.querySelector('.form-body__files')

    // Событие, на изменение инпута
    inputFile.addEventListener('change', async () => {
        const selectFile = inputFile.files[0]

        if (selectFile === null) {
            return
        }

        // Копирование всего html из template, в переменную
        // Для дальнейшего взаимодействия
        const cloneContentTemplate = template.content.cloneNode(true)

        // Поиск dom элементов бокса, бокс был взять из template
        const box = cloneContentTemplate.querySelector('.form-body__input-file')
        const img = cloneContentTemplate.querySelector('.form-body__input-file-img')
        const remove = cloneContentTemplate.querySelector('.form-body__input-delete')
        // ---

        // Оживление бокса
        img.src = await readURL(selectFile)

        remove.addEventListener('click', () => {
            box.remove()

            // Удаление файла из массива
            window.formSelectFile = window.formSelectFile.filter(itm => itm !== selectFile)

            console.log('window.formSelectFile', 'REMOVE', window.formSelectFile)
            // ---
        })
        // ---

        // Вставка бокса на страницу
        contentBody.appendChild(cloneContentTemplate)

        // Вставка файла в массив
        window.formSelectFile.push(selectFile)
        console.log('window.formSelectFile', 'ADD', window.formSelectFile)
        // ---
    })
}

function readURL(file) {
    return new Promise((res, rej) => {
        const reader = new FileReader()
        reader.onload = (e) => res(e.target.result)
        reader.onerror = (e) => rej(e)
        reader.readAsDataURL(file)
    })
}

document.querySelectorAll('.form-body__line--file').forEach(initLoader)

// Заплатка для лоадера в старом дизайне
const fileCustom = document.querySelector(`[data-id="file-custom"]`)
const fileUrl = document.querySelector(`[data-id="file-url"]`)

fileCustom.addEventListener('change', () => {
    const file = fileCustom.files[0] ?? ''
    fileUrl.value = file === '' ? '' : file.name
})
// ---
